<div class="toolbar-user-container">
    <button mat-button type="button" (click)="toggleDropDown()" class="toolbar-user-btn" [class.open]="isOpen()"
        aria-haspopup="true" [attr.aria-expanded]="isOpen()" [attr.aria-label]="'Meniul utilizatorului ' + (currentUser()?.nume ?? '')">
        <span class="flex-row flex-align-start-center">
            <img class="avatar" ngSrc="assets/images/avatars/noavatar.png" width="40" height="40" alt="">
            <span class="name flex-hide-show-gt-sm">{{currentUser()?.nume}}</span>
            <mat-icon class="icon flex-hide-show-gt-sm">keyboard_arrow_down</mat-icon>
        </span>
    </button>

    <div class="dropdown mat-elevation-z1" [class.open]="isOpen()">
        <div class="content">
            <div class="list">
                <button type="button" class="item flex-row flex-align-start-center" mat-ripple (click)="refresh()">
                    <mat-icon class="icon">refresh</mat-icon>
                    <span class="title">Registre</span>
                </button>
                <mat-divider />
                <button type="button" class="item flex-row flex-align-start-center" mat-ripple (click)="get_anyDesk()">
                    <mat-icon class="icon">get_app</mat-icon>
                    <span class="title">AnyDesk</span>
                </button>
                <mat-divider />
                <button type="button" class="item flex-row flex-align-start-center" mat-ripple (click)="showVersion()">
                    <mat-icon class="icon">info</mat-icon>
                    <span class="title">Versiune App</span>
                </button>
                <mat-divider />
                <button type="button" class="item flex-row flex-align-start-center" mat-ripple (click)="iesire()">
                    <mat-icon class="icon">exit_to_app</mat-icon>
                    <span class="title">Logout</span>
                </button>
            </div>
        </div>
    </div>

</div>